exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbody {\n        min-height: initial !important;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Frontend School (Prod)/ui/schools/src/components/main/widgets/src/components/main/widgets/BaseWidget.vue"],"names":[],"mappings":";AAkBA;QACA,+BAAA;CACA","file":"BaseWidget.vue","sourcesContent":["<template>\n    <div>\n        <slot :school-id=\"schoolId\"></slot>\n    </div>\n</template>\n\n<script>\n    export default {\n        name: 'BaseWidget',\n        data() {\n            return {\n                schoolId: this.$route.query.schoolId\n            }\n        }\n    }\n</script>\n\n<style>\n    body {\n        min-height: initial !important;\n    }\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76f56cab","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/main/widgets/BaseWidget.vue
// module id = RwTN
// module chunks = 9